module.exports = __webpack_public_path__ + "img/people.bf7fdd50.png";